import { enumParser } from '#validation/common/parsers';
import { TaxStatus } from '../tax-status.enum';
export const taxStatusParser = enumParser(TaxStatus);
